import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFolderDelete: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="folder-delete"><path d="M10.75 19.25H21.25V6.75H12L10 3.75H2.75V11.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M7.25 14.75L5 17L2.75 19.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M2.75 14.75L5 17L7.25 19.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconFolderDelete;
